export const FREIGHT_TAX = {
    name: "VAT",
    percent: 0.25,
};
export var AddressType;
(function (AddressType) {
    AddressType["BILLING"] = "billing";
    AddressType["DELIVERY"] = "delivery";
    AddressType["OTHER"] = "other";
})(AddressType || (AddressType = {}));
